const translations = {
  title: 'Novo destino',
  title_edit: 'Editando destino',
  bulkRegistration: 'Cadastro em massa',
  type: 'Tipo*',
  additionalFields: 'Campos adicionais'
}

export default translations
